import React from 'react';
import { Alert, Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { reportError } from 'configs/ErrorBoundaryConfig';

class ComponentErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    reportError(error, errorInfo, {
      component: 'ComponentErrorBoundary',
      props: this.props,
      timestamp: new Date().toISOString(),
    });

    // Call the optional onError prop if provided
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });

    // Call the optional onRetry prop if provided
    if (this.props.onRetry) {
      this.props.onRetry();
    }
  };

  render() {
    if (this.state.hasError) {
      // Use custom fallback if provided
      if (this.props.fallback) {
        return this.props.fallback(this.state.error, this.handleRetry);
      }

      // Default inline error display
      return (
        <Alert
          message={this.props.title || 'Component Error'}
          description={
            <Space direction="vertical" size="small">
              <div>
                {this.props.message ||
                  "This component encountered an error and couldn't be displayed."}
              </div>
              {this.props.showRetry !== false && (
                <Button
                  size="small"
                  icon={<ReloadOutlined />}
                  onClick={this.handleRetry}
                >
                  Try Again
                </Button>
              )}
            </Space>
          }
          type="error"
          showIcon
          className={this.props.className}
          style={this.props.style}
        />
      );
    }

    return this.props.children;
  }
}

export default ComponentErrorBoundary;
